import { render, staticRenderFns } from "./VariantModule.vue?vue&type=template&id=33e2b46e&scoped=true&"
import script from "./VariantModule.vue?vue&type=script&lang=js&"
export * from "./VariantModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2b46e",
  null
  
)

export default component.exports